// extracted by mini-css-extract-plugin
export default {"panel":"NewInvestigation-module__panel__aW8yT"};